module.exports = __webpack_public_path__ + "2f7cc875aa926b4d3ae479bcc5208b4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buy-sub-img.png
// module id = 1053
// module chunks = 0